import { render, staticRenderFns } from "./LimitedTextarea.vue?vue&type=template&id=c88c5a14&"
import script from "./LimitedTextarea.vue?vue&type=script&lang=js&"
export * from "./LimitedTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports